import { parseISO } from 'date-fns';
import { dateFns } from '../../helpers/DateFnsUtils';
import _ from 'lodash';

export const parseLoans = (loans, bills, statuses) => {
    if (!loans.length) {
        return [];
    }

    const loansParsed = [];

    for (const loan of loans) {
        const loanParsed = {};

        // get required data

        const loanRequest = loan.loan_request || {};
        const signRequest = loan.sign_request || {};

        const bill = bills.find(bill => bill.id_loan_offer === loanRequest.id_loan_offer) || {};

        // set loan data

        loanParsed.id = loanRequest.id;
        loanParsed.idExternal = loanRequest.id_external;
        loanParsed.idOfferExternal = loanRequest.metadata?.response?.idRequest;
        loanParsed.idSignRequest = signRequest.id;
        loanParsed.formattedName = getFormattedName(signRequest);
        loanParsed.amount = loanRequest.amount || loanRequest.metadata?.response?.amount;
        loanParsed.document = signRequest.person?.documents[0]?.description;
        loanParsed.status = statuses[loanRequest.id_loan_request_status] || '';
        loanParsed.sign_status = signRequest.id_cuotitas_request_status;
        loanParsed.created_at = parseDate(loan.created_at);
        loanParsed.updated_at = loan.updated_at;
        loanParsed.billId = loanRequest.metadata.id_bill_file;
        loanParsed.request_files = bill.request_files;
        loanParsed.creditNumber = loanRequest.metadata.response.NumeroCredito;
        loanParsed.cellPhone = loanRequest.external_person.content.telephone;
        loanParsed.signHash = signRequest.hash;
        loanParsed.signID = signRequest.id;
        loanParsed.detailRequirement = loanRequest?.metadata?.detailRequirement;
        loanParsed.observation = loanRequest?.metadata?.observation;

        // add to loansParsed

        loansParsed.push(loanParsed);
    }

    return loansParsed;
};

const getFormattedName = (loan) => {
    const personAttributes = _.reduce(loan?.person?.attributes, (result, value, key) => {
        result[value.description] = value.value;
        return result;
    }, {});

    const firstName = personAttributes.first_name || loan?.person?.attributes[0]?.value;
    const lastName = personAttributes.last_name || loan?.person?.attributes[1]?.value;
    const fullName = (firstName && lastName) && `${firstName} ${lastName}`;
    return fullName || 'S/D';
};

const parseDate = (date) => {
    let newDate = parseISO(date);
    newDate = dateFns.parse(dateFns.format(newDate, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');
    return newDate;
};

/* const filterByDate = (loansList, filter) => {
    return loansList.filter(loan => isEqual(loan.created_at, filter));
};

const filterByName = (loansList, filter) => {
    return loansList.filter(loan => loan.formattedName.toLowerCase().includes(filter.toLowerCase()));
};

const filterByDocument = (loansList, filter) => {
    return loansList.filter(loan => loan.document.includes(filter));
}; */

export const getIdStore = (stores) => {
    return stores[0]?.id;
};

export function getOffset (page, limit) {
    return page * limit - limit;
}
